import { ROLES } from "../../model/roles";
export default class UtilityService {

  static isInGroup = (role = "", authRole = []) => {
    return authRole?.includes(role);
  };

  static isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  static getModalitaErogazione = (inputValue) => {
    switch (inputValue) {
        case 'Telematica_Asincrona':
            return 'Telematica asincrona';
        case 'Telematica_Sincrona':
            return 'Telematica sincrona';
        case 'Telematica_sincrona':
            return 'Telematica sincrona';
        case 'Presenza':
            return 'Presenza';
        case 'Telematica_Mista':
            return 'Telematica mista';
        case 'Mista_Presenza/Telematica':
            return 'Presenza/Telematica';
        default:
            return 'Nessuna opzione';
    }
}

static showAlert(message, type, duration = 5000) {
  const alertDiv = document.createElement('div');
  alertDiv.id = "notification";
  alertDiv.classList.add('alert', `alert-${type}`);
  alertDiv.innerHTML = `<i className="${UtilityService.getIconClass(type)}"></i><span className="ms-2">${message}</span>`;
  document.body.appendChild(alertDiv);
  setTimeout(() => {
    document.getElementById("notification").remove();
  }, duration);
}

static getIconClass(type) {
  switch (type) {
    case 'success':
      return 'bi bi-check-circle';
    case 'danger':
      return 'bi bi-exclamation-triangle';
    case 'warning':
      return 'bi bi-exclamation-triangle';
    default:
      return 'bi bi-info-circle';
  }
}

static formatDateAndHour = (data) => {
  if(data){
      const opzioniData = { day: '2-digit', month: '2-digit', year: 'numeric' };
      const opzioniOra = { hour: '2-digit', minute: '2-digit' };
  
      const dataFormattata = new Date(data).toLocaleDateString('it-IT', opzioniData);
      const oraFormattata = new Date(data).toLocaleTimeString('it-IT', opzioniOra);
  
      return `${dataFormattata} ${oraFormattata}`;
  }
   return null;
  }

  static formatDate = (input) => {
    const date = new Date(input);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const formatDay = day <= 9 ? '0' + day : day;
    const formatMonth = month <= 9 ? '0' + month : month;
    const formatDate = `${formatDay}/${formatMonth}/${date.getFullYear()}`;
    return formatDate;
}

  static formatModalitaErogazione = (inputValue) => {
    switch (inputValue) {
        case 'asincrona':
            return 'Telematica_Asincrona';
        case 'sincrona':
            return 'Telematica_Sincrona';
        case 'presenza':
            return 'Presenza';
        case 'telematica_mista':
            return 'Telematica_Mista';
        case 'mista_presenza/telematica':
          return 'Mista_Presenza/Telematica';       
        default:
            return 'Nessun opzione';
    }
  }
  static formatModalitaErogazionePerCheckbox = (inputValue) => {
    switch (inputValue) {
        case 'Telematica_Asincrona':
            return 'asincrona';
        case 'Telematica_Sincrona':
            return 'sincrona';
        case 'Presenza':
            return 'presenza';
        case 'Telematica_Mista':
          return 'telematica_mista';    
        case 'Mista_Presenza/Telematica':
          return 'mista_presenza/telematica';    
        default:
            return 'Nessun opzione';
    }
  }

  static rolesAllowedToCreate = (user) => {
    switch (user?.role) {
        case ROLES.ADMIN:
             return ["admin", "course_designer", "docente", "partner", "tutor", "corsista"];
        case ROLES.DEVELOPER:
             return ["admin", "course_designer", "docente", "partner", "tutor", "corsista"];
        case ROLES.COURSE_DESIGNER:
             return ["partner"];
        case ROLES.PARTNER:
             return ["corsista"];
        default:
            return [];
    }

  }

  static getPaymentState = (state) => {
    switch (state) {
        case "Non_pagato":
             return "Non pagato";
        case "Pagato":
             return "Pagato";
        case "Parzialmente_pagato":
             return "Parzialmente pagato";
        default:
            return "";
    }

  }

  static validationForm = (formData, requiredFields) => {
    return requiredFields.filter(field => {
      const value = formData[field]?.toString();
      return !value || value?.trim() === '';
    });
};

  static transformPropertyName = (object, oldProperty, newProperty) => {
    const transformedObject = { ...object };

    if (transformedObject.hasOwnProperty(oldProperty)) {
        transformedObject[newProperty] = transformedObject[oldProperty];
        delete transformedObject[oldProperty];
    }

    return transformedObject;
  };

  static generatePassword = () => {
    const uppercaseChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const lowercaseChars = 'abcdefghijklmnopqrstuvwxyz';
    const specialChars = '!@#$%^&*()-_=+[{]};:<>|./?';
    const numbers = '0123456789';

    const getRandomChar = (charSet) => {
        const randomIndex = Math.floor(Math.random() * (charSet?.length));
        return charSet[randomIndex];
    };

    let password = '';

    password += getRandomChar(uppercaseChars);

    password += getRandomChar(lowercaseChars);

    password += getRandomChar(specialChars);

    password += getRandomChar(numbers);

    const remainingLength = 8 - password?.length;
    for (let i = 0; i < remainingLength; i++) {
        const charSet = uppercaseChars + lowercaseChars + specialChars + numbers;
        password += getRandomChar(charSet);
    }
    password = password.split('').sort(() => Math.random() - 0.5).join('');
    return password;
  };

  static formatDateFillInput = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
        return '';
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

  static generateCourseCode() {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    const charactersLength = characters?.length;
    let code = '';
    for (let i = 0; i < 16; i++) {
      code += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return code;
  }

  static generateIconContenuti(contenuto) {
    switch (contenuto?.tipo_contenuto) {
      case 'testo-immagini':
        return <span className="bi bi-file-earmark-font text-dark"></span>;
      case 'audio-video':
        return <span className="bi bi-file-earmark-play text-dark"></span>;
      case 'pdf':
        return <span className="bi bi-file-earmark-pdf"></span>;
      case 'test':
        return <span className="bi bi-file-earmark-text"></span>;
      default:
        return <span className="bi bi-file-earmark-font text-dark"></span>; 
    }
  }
  
  static getBadgeColorClass = (paymentState) => {
    switch(paymentState) {
      case 'Pagato':
        return 'text-bg-success';
      case 'Parzialmente_pagato':
        return 'text-bg-warning';
      case 'Non_pagato':
      default:
        return 'text-bg-danger';
    }
  };

}
